/**
 * Waypoints Library
 * Vendor library for scroll detection and triggers
 * Used by patterns that need scroll-based interactions
 */

import 'waypoints/lib/jquery.waypoints.min';
import 'waypoints/lib/shortcuts/inview.min';

// Expose Waypoint globally for use in patterns and child themes
if (typeof window !== 'undefined') {
  // Waypoints automatically attaches to window.Waypoint
  // This ensures it's available globally
  window.Waypoint = window.Waypoint || {};
}

export default window.Waypoint;
